/**
 * Feed del plan de producción + instancia del motor de simulación.
 *
 * El feed es pesado (BOM completo) y solo cambia con el refresco del lakehouse
 * (15–30 min) → staleTime alto y sin refetch on focus. El motor se construye
 * una vez por carga de feed; la simulación posterior es 100% en memoria.
 */
import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { planProduccionApi } from '@/services/api'
import { PlanEngine } from '@/utils/planProduccion/engine'

export function usePlanFeed(
  empresa: string,
  anio: number,
  linea?: string,
  formato?: string,
  options?: { trustOverduePurchases?: boolean; planFromZero?: boolean },
) {
  const trustOverduePurchases = options?.trustOverduePurchases !== false
  const planFromZero = options?.planFromZero === true
  const query = useQuery({
    queryKey: ['plan-produccion-feed', empresa, anio, linea || '', formato || ''],
    queryFn: () => planProduccionApi.getFeed({ empresa, anio, linea: linea || undefined, formato: formato || undefined }),
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  })

  const feed = query.data?.data
  const engine = useMemo(
    () => (feed ? new PlanEngine(feed, { trustOverduePurchases, ignoreInProgress: planFromZero }) : null),
    [feed, trustOverduePurchases, planFromZero],
  )

  return { ...query, feed, engine }
}
